module.exports = __webpack_public_path__ + "img/bg.2e4431fc.png";